// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-nextjs-toast] {
  &[data-hidden='true'] {
    display: none;
  }
}

.dev-tools-indicator-menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-background-100);
  border: 1px solid var(--color-gray-alpha-400);
  background-clip: padding-box;
  box-shadow: var(--shadow-menu);
  border-radius: var(--rounded-xl);
  position: absolute;
  font-family: var(--font-stack-sans);
  z-index: 3;
  overflow: hidden;
  opacity: 0;
  outline: 0;
  min-width: 248px;
  transition: opacity var(--animate-out-duration-ms)
    var(--animate-out-timing-function);

  &[data-rendered='true'] {
    opacity: 1;
    scale: 1;
  }
}

.dev-tools-indicator-inner {
  padding: 6px;
  width: 100%;
}

.dev-tools-indicator-item {
  display: flex;
  align-items: center;
  padding: 8px 6px;
  height: var(--size-36);
  border-radius: 6px;
  text-decoration: none !important;
  user-select: none;
  white-space: nowrap;

  svg {
    width: var(--size-16);
    height: var(--size-16);
  }

  &:focus-visible {
    outline: 0;
  }
}

.dev-tools-indicator-footer {
  background: var(--color-background-200);
  padding: 6px;
  border-top: 1px solid var(--color-gray-400);
  width: 100%;
}

.dev-tools-indicator-item[data-selected='true'] {
  cursor: pointer;
  background-color: var(--color-gray-200);
}

.dev-tools-indicator-label {
  font-size: var(--size-14);
  line-height: var(--size-20);
  color: var(--color-gray-1000);
}

.dev-tools-indicator-value {
  font-size: var(--size-14);
  line-height: var(--size-20);
  color: var(--color-gray-900);
  margin-left: auto;
}

.dev-tools-indicator-issue-count {
  --color-primary: var(--color-gray-800);
  --color-secondary: var(--color-gray-100);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: var(--size-40);
  height: var(--size-24);
  background: var(--color-background-100);
  border: 1px solid var(--color-gray-alpha-400);
  background-clip: padding-box;
  box-shadow: var(--shadow-small);
  padding: 2px;
  color: var(--color-gray-1000);
  border-radius: 128px;
  font-weight: 500;
  font-size: var(--size-13);
  font-variant-numeric: tabular-nums;

  &[data-has-issues='true'] {
    --color-primary: var(--color-red-800);
    --color-secondary: var(--color-red-100);
  }

  .dev-tools-indicator-issue-count-indicator {
    width: var(--size-8);
    height: var(--size-8);
    background: var(--color-primary);
    box-shadow: 0 0 0 2px var(--color-secondary);
    border-radius: 50%;
  }
}

.dev-tools-indicator-shortcut {
  display: flex;
  gap: 4px;

  kbd {
    width: var(--size-20);
    height: var(--size-20);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--rounded-md);
    border: 1px solid var(--color-gray-400);
    font-family: var(--font-stack-sans);
    background: var(--color-background-100);
    color: var(--color-gray-1000);
    text-align: center;
    font-size: var(--size-12);
    line-height: var(--size-16);
  }
}

.dev-tools-grabbing {
  cursor: grabbing;

  > * {
    pointer-events: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/next-devtools/dev-overlay/components/devtools-indicator/devtools-indicator.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,6CAA6C;EAC7C,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,mCAAmC;EACnC,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB;sCACoC;;EAEpC;IACE,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;;EAEnB;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;EACvC,6CAA6C;EAC7C,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;;EAElC;IACE,qCAAqC;IACrC,uCAAuC;EACzC;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,gCAAgC;IAChC,4CAA4C;IAC5C,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;;EAER;IACE,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,uCAAuC;IACvC,mCAAmC;IACnC,uCAAuC;IACvC,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;;EAEhB;IACE,oBAAoB;EACtB;AACF","sourcesContent":["[data-nextjs-toast] {\n  &[data-hidden='true'] {\n    display: none;\n  }\n}\n\n.dev-tools-indicator-menu {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background: var(--color-background-100);\n  border: 1px solid var(--color-gray-alpha-400);\n  background-clip: padding-box;\n  box-shadow: var(--shadow-menu);\n  border-radius: var(--rounded-xl);\n  position: absolute;\n  font-family: var(--font-stack-sans);\n  z-index: 3;\n  overflow: hidden;\n  opacity: 0;\n  outline: 0;\n  min-width: 248px;\n  transition: opacity var(--animate-out-duration-ms)\n    var(--animate-out-timing-function);\n\n  &[data-rendered='true'] {\n    opacity: 1;\n    scale: 1;\n  }\n}\n\n.dev-tools-indicator-inner {\n  padding: 6px;\n  width: 100%;\n}\n\n.dev-tools-indicator-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 6px;\n  height: var(--size-36);\n  border-radius: 6px;\n  text-decoration: none !important;\n  user-select: none;\n  white-space: nowrap;\n\n  svg {\n    width: var(--size-16);\n    height: var(--size-16);\n  }\n\n  &:focus-visible {\n    outline: 0;\n  }\n}\n\n.dev-tools-indicator-footer {\n  background: var(--color-background-200);\n  padding: 6px;\n  border-top: 1px solid var(--color-gray-400);\n  width: 100%;\n}\n\n.dev-tools-indicator-item[data-selected='true'] {\n  cursor: pointer;\n  background-color: var(--color-gray-200);\n}\n\n.dev-tools-indicator-label {\n  font-size: var(--size-14);\n  line-height: var(--size-20);\n  color: var(--color-gray-1000);\n}\n\n.dev-tools-indicator-value {\n  font-size: var(--size-14);\n  line-height: var(--size-20);\n  color: var(--color-gray-900);\n  margin-left: auto;\n}\n\n.dev-tools-indicator-issue-count {\n  --color-primary: var(--color-gray-800);\n  --color-secondary: var(--color-gray-100);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: var(--size-40);\n  height: var(--size-24);\n  background: var(--color-background-100);\n  border: 1px solid var(--color-gray-alpha-400);\n  background-clip: padding-box;\n  box-shadow: var(--shadow-small);\n  padding: 2px;\n  color: var(--color-gray-1000);\n  border-radius: 128px;\n  font-weight: 500;\n  font-size: var(--size-13);\n  font-variant-numeric: tabular-nums;\n\n  &[data-has-issues='true'] {\n    --color-primary: var(--color-red-800);\n    --color-secondary: var(--color-red-100);\n  }\n\n  .dev-tools-indicator-issue-count-indicator {\n    width: var(--size-8);\n    height: var(--size-8);\n    background: var(--color-primary);\n    box-shadow: 0 0 0 2px var(--color-secondary);\n    border-radius: 50%;\n  }\n}\n\n.dev-tools-indicator-shortcut {\n  display: flex;\n  gap: 4px;\n\n  kbd {\n    width: var(--size-20);\n    height: var(--size-20);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: var(--rounded-md);\n    border: 1px solid var(--color-gray-400);\n    font-family: var(--font-stack-sans);\n    background: var(--color-background-100);\n    color: var(--color-gray-1000);\n    text-align: center;\n    font-size: var(--size-12);\n    line-height: var(--size-16);\n  }\n}\n\n.dev-tools-grabbing {\n  cursor: grabbing;\n\n  > * {\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
